// extracted by mini-css-extract-plugin
module.exports = {"item":"Reminds_item_2bKZk"};